import { createContext, useState, useContext } from "react";

const SelectedDateContext = createContext();

export const SelectedDateProvider = ({ children }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [availableSchools, setAvailableSchools] = useState([]);

  return (
    <SelectedDateContext.Provider
      value={{
        selectedDate,
        setSelectedDate,
        selectedSchool,
        setSelectedSchool,
        availableSchools,
        setAvailableSchools,
      }}
    >
      {children}
    </SelectedDateContext.Provider>
  );
};

export const useSelectedDate = () => {
  const context = useContext(SelectedDateContext);
  if (!context) {
    throw new Error("useSelectedDate must be used within a SelectedDateProvider");
  }
  return context;
};
